import { z } from 'zod';

/////////////////////////////////////////
// PERMITS STEPS DOCUMENTS SCHEMA
/////////////////////////////////////////

export const PermitsStepsDocumentsSchema = z.object({
  id: z.bigint(),
  permits_step_id: z.bigint().nullable(),
  documents_type_id: z.number().int().nullable(),
  documents_template_id: z.number().int().nullable(),
})

export type PermitsStepsDocuments = z.infer<typeof PermitsStepsDocumentsSchema>

export default PermitsStepsDocumentsSchema;
